export default {
    columns: [
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.company.id.description",//"Código interno",
          label: "wkt.admin.qbuilder.model.company.id.text",//"Código",
          field: "id"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.company.cif.description",//"CIF",
          label: "wkt.admin.qbuilder.model.company.cif.text",//"CIF",
          field: "cif"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.company.name.description",//"Nombre",
          label: "wkt.admin.qbuilder.model.company.name.text",//"Nombre",
          field: "name"
        },
        {
          field: "creationDate",
          type: "DATETIME",
          desc:  "wkt.admin.qbuilder.model.company.creation-date.description",//"Fecha de creación",
          label: "wkt.admin.qbuilder.model.company.creation-date.text",//"F. Creación",
          formatter: 'formatDateTime'
        },
        {
          field: "currentSeats",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.company.current-seats.description",//"Trabajadores actuales",
          label: "wkt.admin.qbuilder.model.company.current-seats.text",//"T. Actuales"
        },
        {
          field: "currentSeatLimit",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.company.curent-seat-limit.description",//"Trabajadores máximos",
          label: "wkt.admin.qbuilder.model.company.curent-seat-limit.text",//"T. máximos"
        },
        {
          field: "licenseEnabled",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.company.license-enabled.description",//"Licencia habilitada",
          label: "wkt.admin.qbuilder.model.company.license-enabled.text",//"Licencia habilitada",
          formatter: 'formatChoice',
          choices: [ { 'key':'0', 'value':'wkt.admin.common.no'/*'NO'*/ },
                     { 'key':'1', 'value':'wkt.admin.common.yes'/*'SI'*/ } ]
        },
        {
          field: "licensePlanExpires",
          type: "DATETIME",
          desc: "wkt.admin.qbuilder.model.company.license-plan-expires.description",//"Fin de licencia",
          label: "wkt.admin.qbuilder.model.company.license-plan-expires.text",//"Fin licencia",
          formatter: 'formatDate'
        },
        {
          field: "licensePlanAutonrenew",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.company.license-pan-autorenew.description",//"Renovar licencia automáticamente",
          label: "wkt.admin.qbuilder.model.company.license-pan-autorenew.text",//"Renovar Aut.",
          formatter: 'formatChoice',
          choices: [ { 'key':'0', 'value':'wkt.admin.common.no'/*'NO'*/ },
                     { 'key':'1', 'value':'wkt.admin.common.yes'/*'SI'*/ } ]
        },
        {
          field: "licensePlan",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.company.license-type.description",//"Tipo licencia",
          label:  "wkt.admin.qbuilder.model.company.license-type.text",//"Tipo licencia",
          formatter: 'formatChoice',
          choices: [ {  'key':'0', 'value':'wkt.admin.qbuilder.model.company.choices.free'/*'Gratuita'*/ },
                     {  'key':'1', 'value':'wkt.admin.qbuilder.model.company.choices.monthly'/*'Mensual'*/ },
                     {  'key':'2', 'value':'wkt.admin.qbuilder.model.company.choices.annual'/*'Anual'*/ } ]
        },
        {
          field: "enabled",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.company.enabled.description",//"Habilitado",
          label: "wkt.admin.qbuilder.model.company.enabled.text",//"Habilitado",
          formatter: 'formatChoice',
          choices: [ { 'key':'0', 'value':'wkt.admin.common.no'/*'NO'*/ },
                     { 'key':'1', 'value':'wkt.admin.common.yes'/*'SI'*/ } ]
        }
      ],
}